export default __webpack_public_path__ + "static/pablo-875f09198e4754052703f88707d95c38.jpg";